
const config = {
  options: ['inline', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker'],
  inline: { inDropdown: true },
  list: { inDropdown: true },
  textAlign: { inDropdown: true },
}

export default config;
